import React from "react";
import { getRequest } from "sharedUtils/httpUtils";
import MUIDataTable from "mui-datatables";
import { convertToNumericMonthAndDayAndYearAndTime } from "sharedUtils/timeUtils";
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
import { CheckIconBlack } from "../../icons";
import PenIcon from "components/icons/PenIcon";

const { DateTime } = require("luxon");

class ImpactMerchantData extends React.Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();

        this.state = {
            merchants: [],
            merchantsLoading: false,
            MerchantsTable: {
                title: "Affiliate merchants",
                options: {
                    selectableRows: "multiple",
                    rowsPerPage: 100,
                    sortOrder: {
                        name: 'merchantName',
                        direction: 'asc'
                    },
                },
                getTheme: () => createTheme({
                    overrides: {
                        MUIDataTableBodyRow: {
                            root: {
                                '&:nth-child(odd)': {
                                    backgroundColor: '#F9F9F9'
                                },
                                cursor: 'pointer'
                            }
                        },
                    }
                })
            },
        };
    }

    componentDidMount = () => {
        window.scrollTo({ left: 0, top: 0, behavior: 'auto' });
        this.getMerchants();
    };

    getMerchants = async () => {
        let url = `/api/Merchant/GetImpactMerchants`;

        this.setState({ merchantsLoading: true });

        try {
            const merchants = await getRequest(url);

            this.setState({
                merchants,
                merchantsLoading: false,
            });
        } catch (error) {
            console.error("Error fetching merchants:", error);
            this.setState({ merchants: [], merchantsLoading: false });
        }
    };

    onTabChange = (tab) => {
        this.setState({ tab });
    }

    render() {
        const columns = [
    {
        name: "hostname",
        label: "Hostname",
        options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => {
                return <span>{value}</span>;
            }
        }
    },
    {
        name: "advertiserId",
        label: "Advertiser ID",
        options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => {
                return <span>{value}</span>;
            }
        }
    },
    {
        name: "advertiserName",
        label: "Advertiser Name",
        options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => {
                return <b>{value}</b>;
            }
        }
    },
    {
        name: "advertiserUrl",
        label: "Advertiser URL",
        options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => {
                return (
                    <a href={value} target="_blank" rel="noopener noreferrer">
                        {value}
                    </a>
                );
            }
        }
    },
    {
        name: "campaignId",
        label: "Campaign ID",
        options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => {
                return <span>{value}</span>;
            }
        }
    },
    {
        name: "campaignName",
        label: "Campaign Name",
        options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => {
                return <b>{value}</b>;
            }
        }
    },
    {
        name: "campaignUrl",
        label: "Campaign URL",
        options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => {
                return (
                    <a href={value} target="_blank" rel="noopener noreferrer">
                        {value}
                    </a>
                );
            }
        }
    },
    {
        name: "campaignDescription",
        label: "Campaign Description",
        options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => {
                return (
                    <div
                        style={{
                            maxWidth: "200px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                        }}
                        title={value}
                    >
                        {value}
                    </div>
                );
            }
        }
    },
    {
        name: "campaignLogoUrl",
        label: "Campaign Logo",
        options: {
            filter: false,
            sort: false,
            customBodyRender: (value) => {
                return (
                    <img
                        src={value}
                        alt="Campaign Logo"
                        style={{ maxWidth: "100px", maxHeight: "40px" }}
                    />
                );
            }
        }
    },
    {
        name: "contractStatus",
        label: "Contract Status",
        options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => {
                return (
                    <p style={{ textAlign: "center", margin: 0 }}>
                        {value === "Active" ? "🟢 Active" : "🔴 Inactive"}
                    </p>
                );
            }
        }
    },
    {
        name: "trackingLink",
        label: "Tracking Link",
        options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => {
                return (
                    <a href={value} style={{ width: "300px", wordWrap: "break-word", display: "inline-block" }} target="_blank" rel="noopener noreferrer">
                        {value}
                    </a>
                )
            }
        }
    },
    {
        name: "allowsDeeplinking",
        label: "Allows Deeplinking",
        options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => {
                return (
                    <p style={{ textAlign: "center", margin: 0 }}>
                        {value ? "✅ Yes" : "❌ No"}
                    </p>
                );
            }
        }
    },
    {
        name: "payoutPercentage",
        label: "Payout Percentage",
        options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => {
                return (
                    <p style={{ textAlign: "center", margin: 0 }}>
                        {value ? `${value}` : "-"}
                    </p>
                );
            }
        }
    },
    {
        name: "referralPeriod",
        label: "Referral Period",
        options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => {
                return `${value}`;
            }
        }
    },
    {
        name: "referralPeriodUnit",
        label: "Referral Period Unit",
        options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => {
                return `${value}`;
            }
        }
    }
];

        return (
            <div>
                <ThemeProvider theme={this.state.MerchantsTable.getTheme()}>
                    <MUIDataTable
                        title={
                            <div style={{ fontFamily: "'Archivo', sans-serif" }}>
                                <p style={{ fontSize: '22px', marginTop: "20px" }}>{this.props.affiliateProgramManager?.name + " merchants" ?? "No affiliate selected"}</p>
                            </div>
                        }
                        data={this.state.merchants}
                        columns={columns}
                        options={{
                            ...this.state.MerchantsTable.options,
                            textLabels: {
                                body: { noMatch: this.state.merchantsLoading ? "LOADING..." : "No data available" },
                            },
                            selectableRows: "none",
                        }}
                        ref={this.tableRef}
                    />
                </ThemeProvider>
            </div>
        );
    }
}

export default ImpactMerchantData;
